import { useState, useEffect } from "react";

export default function GroupPriceInput({
  groupName,
  comboGroup,
  comboList,
  groupBy,
  setComboList,
}) {
  // Utility: Clean input and return valid money string with 2 dp
  const cleanAndFormatMoneyInput = (raw) => {
    let cleaned = raw.replace(/[^\d.]/g, "");
    const firstDot = cleaned.indexOf(".");
    if (firstDot !== -1) {
      cleaned =
        cleaned.slice(0, firstDot + 1) +
        cleaned.slice(firstDot + 1).replace(/\./g, "");
    }
    const num = parseFloat(cleaned);
    return isNaN(num) ? "" : num.toFixed(2);
  };

  // Get current values from group
  const groupPrices = comboGroup.map((c) => c.price).filter((p) => typeof p === "number");
  const uniquePrices = [...new Set(groupPrices)];

  const displayInitialValue =
    uniquePrices.length === 1 ? uniquePrices[0].toFixed(2) : "";

  const [tempValue, setTempValue] = useState(displayInitialValue);

  //   put commas where necessary
  const formatWithCommas = (value) => {
    const [intPart, decimalPart] = value.split(".");
    const formatted = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return decimalPart ? `${formatted}.${decimalPart}` : formatted;
  };

  useEffect(() => {
    if (uniquePrices.length === 1) {
      setTempValue(formatWithCommas(uniquePrices[0].toFixed(2)));
    } else {
      setTempValue("");
    }
  }, [groupPrices.join(",")]);

  const handleChange = (e) => {
    setTempValue(e.target.value);
  };

  const handleBlur = () => {
    const cleaned = cleanAndFormatMoneyInput(tempValue);
    if (cleaned === "") return;

    const floatVal = parseFloat(cleaned);
    const updated = comboList.map((c) =>
      c.options?.[groupBy] === groupName
        ? { ...c, price: floatVal, meta: { ...(c.meta || {}), priceDirty: true } }
        : c
    );

    setComboList(updated);
    setTempValue(formatWithCommas(floatVal.toFixed(2)));
  };

  return (
    <div className="relative flex-1 max-w-[10em]" onClick={(e) => e.stopPropagation()}>
      <span className="absolute left-2 top-1/2 -translate-y-1/2 text-[14px] font-medium text-[#333]">
        KES
      </span>
      <input
        type="text"
        inputMode="decimal"
        value={tempValue}
        onChange={handleChange}
        onBlur={handleBlur}
        placeholder={
          uniquePrices.length > 1
            ? `${formatWithCommas(Math.min(...uniquePrices).toFixed(2))} – ${formatWithCommas(Math.max(...uniquePrices).toFixed(2))}`
            : "0.00"
        }
        className="pl-[3em] border border-[#8e8e8e] w-full py-[5px] px-[5px] rounded text-[14px] font-medium bg-[#ffffff]"
      />
    </div>
  );
}
